import { BubbleGameBoard } from 'js/bubbleCore/BubbleGameBoard';
import { 
  IEvent,
  EventType,
  createChainChangedEvent,
} from 'js/bubbleCore/events';
import { createFireBubble } from 'js/bubbleCore/handlers/createFireBubble';

export function handleChain(board: BubbleGameBoard): void {
  const fireEvery = board.getData().config.fireEvery;
  const state = board.getData().state;
  const events = board.getEventsQueue();

  const unsuccessful = board.getEventsQueue()
    .some((event) => event.type === EventType.UnsuccessfulMove);
  const successful = board.getEventsQueue()
    .some((event) => event.type === EventType.SuccessfulMove)
  
  if (unsuccessful && state.chain > 0) {
    state.chain = 0;
    events.push(createChainChangedEvent(0, false));
  } else if (successful) {
    state.chain++;
    const bonus = state.chain % fireEvery === 0;
    events.push(createChainChangedEvent(state.chain, bonus));
    if (bonus) createFireBubble(board);
  }
}